module.exports = __webpack_public_path__ + "static/media/Industrial_Insurance.d39f63a5.svg";